// Mock data for A.T.O.M. tribute band website
// NOTE: All data below is MOCKED for the frontend-only build.

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "The Show", path: "/the-show" },
  { label: "Events", path: "/events" },
  { label: "Media", path: "/media" },
  { label: "EPK", path: "/epk" },
  { label: "Contact", path: "/contact" },
];

const ASSET = "https://customer-assets-rejwkqb3.emergentagent.net/job_atom-interactive-3/artifacts";

export const IMAGES = {
  heroBand: `${ASSET}/40ev685r_2025-08-12_12-17-05.webp`,
  bandGroupWhite: `${ASSET}/5dned6yo_2025-05-24_18-08-03.jpg`,
  seeYouSoon: `${ASSET}/5c5uy0wv_2025-12-23_17-17-20.jpg`,
  allWhiteTribute: `${ASSET}/ar9roigx_2025-12-23_17-18-00.webp`,
  facebookPreview: `${ASSET}/1fzhe3oa_2025-05-24_18-07-01.jpg`,
  epk: `${ASSET}/y4y2kf4j_The%20boys%20One.jpg`,
};

export const GALLERY = [
  { src: `${ASSET}/joe5gfqk_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2006_21_03%20PM.png`, alt: "The full A.T.O.M. band in all white against a black backdrop" },
  { src: `${ASSET}/hgvd0e9t_da%20boys.jpg`, alt: "Three A.T.O.M. members in white backstage" },
  { src: `${ASSET}/r84kpkm5_Moon.jpg`, alt: "A.T.O.M. members in white aboard the SuperCruise" },
  { src: `${ASSET}/w93biazb_daboys.webp`, alt: "A.T.O.M. band members together before the show" },
  { src: `${ASSET}/lajshkiz_ChatGPT%20Image%20Jan%205%2C%202026%2C%2003_47_50%20PM.png`, alt: "A.T.O.M. promotional artwork" },
  { src: `${ASSET}/781v3iyz_Atom%20Band_card.jpg`, alt: "A.T.O.M. band group photo with the Tribute to Frankie Beverly & Maze sign" },
  { src: `${ASSET}/vndh0dyv_cafe%20Paul1.webp`, alt: "Lead vocalist performing in all white on a blue-lit stage" },
  { src: `${ASSET}/rbhrfz14_cafe%20ron%203.webp`, alt: "Percussionist in a white hat behind the congas" },
  { src: `${ASSET}/c655as99_BACK%20STAGE.jpg`, alt: "A.T.O.M. members together backstage" },
  { src: `${ASSET}/qpye8yfn_577177469_25051112057862727_6782856933848040661_n.jpg`, alt: "Lead vocalist performing under blue and purple stage lights" },
  { src: `${ASSET}/oae6ahtm_260074645769253768.jpg`, alt: "SIXX \u2013 lead vocalist studio portrait in white" },
  { src: `${ASSET}/apmmjxha_3014599314884819967.webp`, alt: "Paul Bumbry and guest sharing a smile together" },
  { src: `${ASSET}/61d0f2cj_1740027949827.webp`, alt: "Percussionist on chimes and timbales during the show" },
  { src: `${ASSET}/jv6exo02_448315266_1849639202128275_489957599488829541_n.webp`, alt: "Paul Bumbry on congas in a white hat and shades under stage lights" },
  { src: `${ASSET}/v2gxlpa1_471726104_10229479117942134_6840527407895653469_n.webp`, alt: "Lead vocalist performing in all white with a ballroom chandelier behind" },
  { src: `${ASSET}/jm0znzha_429661334_1784187975340065_6380827287239303058_n.jpg`, alt: "Vocalist commanding the stage at City Winery" },
  { src: `${ASSET}/e32qbq4l_449229298_1857133254712203_6822117307159703518_n.jpg`, alt: "Band member in a white suit backstage in the dressing room" },
  { src: `${ASSET}/ca736prs_448531291_10227262664292178_7176069880722774328_n.jpg`, alt: "Two A.T.O.M. members in white posing backstage" },
  { src: `${ASSET}/8zuvfi22_20250511_192538.webp`, alt: "A.T.O.M. band all in white backstage in the dressing room" },
  { src: `${ASSET}/27tje306_20250222_122122.webp`, alt: "The A.T.O.M. band and friends together on the cruise" },
  { src: `${ASSET}/46md3ou8_20250220_155213.webp`, alt: "Congas on stage bathed in purple light" },
  { src: `${ASSET}/0n7j5fmi_20250220_162520.webp`, alt: "Percussionist behind the congas facing the theater" },
  { src: `${ASSET}/onmaczxj_20250220_155022.webp`, alt: "Band member in the theater seats before the show" },
  { src: `${ASSET}/9vt90vm9_20250220_154347.webp`, alt: "A.T.O.M. percussionist and band during soundcheck" },
  { src: `${ASSET}/7utjz72s_20250220_154304.webp`, alt: "Backstage setup with the crew before the show" },
  { src: `${ASSET}/nhgp1fjc_20250220_154423.webp`, alt: "Percussionist at his station inside the theater" },
  { src: `${ASSET}/uzu3g2eq_20250220_154904%20%281%29.webp`, alt: "Congas set up facing the grand theater seats" },
  { src: `${ASSET}/2zhu02mh_20250220_155009%20%281%29.webp`, alt: "Full A.T.O.M. band on stage from the camera rig" },
  { src: `${ASSET}/5c5uy0wv_2025-12-23_17-17-20.jpg`, alt: "Paul Bumbry on congas at World Cafe Live" },
  { src: `${ASSET}/40ev685r_2025-08-12_12-17-05.webp`, alt: "A.T.O.M. full band on stage under the tribute banner" },
  { src: `${ASSET}/5dned6yo_2025-05-24_18-08-03.jpg`, alt: "Lead vocalist in all white under stage lights" },
  { src: `${ASSET}/1fzhe3oa_2025-05-24_18-07-01.jpg`, alt: "Percussionist performing on congas outdoors" },
  { src: `${ASSET}/ar9roigx_2025-12-23_17-18-00.webp`, alt: "Vocalist engaging the crowd at World Cafe Live" },
];

export const VIDEOS = [
  {
    id: "nashville-love",
    title: "Nashville Love",
    subtitle: "Call it Nashville Love",
    youtubeId: "kxKQ1pp9M1U",
    description: "A soulful live moment captured in Nashville that shows the pure connection between A.T.O.M. and their audience.",
  },
  {
    id: "new-day",
    title: "New Day (Single)",
    subtitle: "Official Single",
    youtubeId: "PHtrMj_alM4",
    description: "\"New Day\" is a smooth, energetic groove that captures the joy of leaving the past behind and embracing a new chapter. With a pulsing rhythm section, velvety vocals, and vibrant brass.",
  },
  {
    id: "frankie-flowers",
    title: "Frankie's Flowers",
    subtitle: "Official Video",
    youtubeId: "ZapFV-6I4jc",
    description: "A heartfelt tribute to the legendary Frankie Beverly. This video captures the soul, the movement, and the legacy of a time when hand dancing and stepping brought people together in rhythm and love.",
  },
  {
    id: "cant-get-over-you",
    title: "Can't Get Over You",
    subtitle: "2024 Capital Jazz SuperCruise",
    youtubeId: "jxOrRDIU6nM",
    description: "Showcases A.T.O.M. at their absolute best. Delivering soulful grooves, timeless rhythm, and polished musicianship, the band brought classic soul and R&B to life aboard the ship.",
  },
  {
    id: "before-i-let-go",
    title: "Before I Let Go",
    subtitle: "2025 Capital Jazz SuperCruise",
    youtubeId: "IimAn0PQh08",
    description: "Ignited the crowd from the very first groove. A.T.O.M. delivered a high-energy, feel-good performance that had the audience singing along, moving, and fully locked into the moment.",
  },
  {
    id: "we-are-one",
    title: "We Are One (ft. Mike Phillips)",
    subtitle: "2025 Capital Jazz SuperCruise",
    youtubeId: "bxe7vkXPpK8",
    description: "Turned into an unforgettable moment when the audience was surprised by saxophonist Mike Phillips joining A.T.O.M. on stage and absolutely killing it.",
  },
  {
    id: "joy-and-pain",
    title: "Joy and Pain",
    subtitle: "Live Performance",
    youtubeId: "opms9g8Yd4A",
    description: "A.T.O.M. delivers a soulful rendition of the timeless anthem, capturing the bittersweet groove and joyful energy that defines the Frankie Beverly & Maze legacy.",
  },
];

// Events use ISO dates so the calendar can auto-filter out past shows.
export const EVENTS = [
  { iso: "2026-10-24", venue: "All White Frankie Tribute", address: "HEMEN Lounge, 617 S Pickett St", city: "Alexandria, VA 22304", note: "" },
  { iso: "2026-12-05", venue: "Boswell Hall \u2013 All White Masquerade Party", address: "Bowie, Maryland", city: "", note: "" },
  { iso: "2026-12-13", venue: "Keystone Korner Baltimore", address: "1350 Lancaster Street", city: "Baltimore, MD 21231", note: "" },
  { iso: "2026-12-20", venue: "The Tin Pan", address: "8982 Quioccasin Road", city: "Richmond, VA 23229", note: "" },
];

// Returns only upcoming events (today or later), sorted, with display fields derived.
export const getUpcomingEvents = () => {
  const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return EVENTS.filter((e) => new Date(e.iso + "T00:00:00") >= today)
    .sort((a, b) => new Date(a.iso) - new Date(b.iso))
    .map((e) => {
      const d = new Date(e.iso + "T00:00:00");
      return {
        ...e,
        day: String(d.getDate()).padStart(2, "0"),
        month: MONTHS[d.getMonth()],
        year: d.getFullYear(),
        date: d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }),
      };
    });
};

export const COMMITMENTS = [
  { title: "Respect for Legacy", text: "Every note we play honors the 50+ year legacy of Frankie Beverly & Maze. We understand this music's deep cultural significance.", icon: "Heart" },
  { title: "Musical Excellence", text: "Seasoned professionals who bring authentic soul, R&B, and funk musicianship to every performance. No shortcuts, no backing tracks.", icon: "Music" },
  { title: "Crowd Connection", text: "We don't just perform\u2014we create moments of joy, dancing, and community that your audience will remember forever.", icon: "Users" },
  { title: "Professional Standards", text: "Full production readiness, punctual soundchecks, professional attire, and clear communication from booking to load-out.", icon: "Award" },
];

export const VENUE_OPTIONS = [
  "City Winery Nashville", "Keystone Korner Baltimore", "Tin Pan Richmond",
  "Bethesda Blues & Jazz", "Birchmere", "Other",
];

export const EVENT_TYPES = [
  "Music Festival", "Corporate Event", "Theater/Concert Hall", "Casino/Resort",
  "Private Celebration", "Outdoor Concert Series", "Alumni Event", "Other",
];

export const BUDGET_RANGES = [
  "Under $10,000", "$10,000 - $20,000", "$20,000 - $35,000", "$35,000 - $50,000", "$50,000+",
];

export const CONTACT_INFO = {
  email: "info@atom-band.com",
  phones: ["(240) 274-6000", "(301) 437-2485"],
  location: "Washington DC - Nationwide",
  facebook: "https://www.facebook.com/groups/431810379580661",
};

export const SETLIST_HIGHLIGHTS = [
  "Before I Let Go", "Joy and Pain", "Golden Time of Day", "We Are One",
  "Happy Feelin's", "Can't Get Over You", "Southern Girl", "Back In Stride",
];

// localStorage helpers for mocked form persistence
export const saveToStorage = (key, data) => {
  try {
    const existing = JSON.parse(localStorage.getItem(key) || "[]");
    existing.push({ ...data, submittedAt: new Date().toISOString() });
    localStorage.setItem(key, JSON.stringify(existing));
    return true;
  } catch (e) {
    return false;
  }
};

export const getFromStorage = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "[]");
  } catch (e) {
    return [];
  }
};
